module.exports = __webpack_public_path__ + "static/media/play-button.5eff131f.svg";